import PriceTabsMobileTable from './PriceTabsMobileTable'

export default PriceTabsMobileTable